import React from "react";

interface SkeletonProps {
  className?: string;
  titleLineStyle?: string;
  linesStyle?: string;
  lines?: number;
  lineHeight?: string;
}

export const Skeleton = ({
  className = "",
  lines = 10,
  lineHeight = "2",
  titleLineStyle,
  linesStyle = "",
}: SkeletonProps) => {
  return (
    <div role="status" className={`max-w-sm animate-pulse ${className}`}>
      <div
        className={`h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4 ${titleLineStyle}`}
      ></div>
      {lines > 0 &&
        Array.from({ length: lines }).map((_, index) => (
          <div
            key={index}
            className={`h-${lineHeight} bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5 ${linesStyle}`}
          ></div>
        ))}
      <span className="sr-only">Loading...</span>
    </div>
  );
};
